function plugin(Vue) {
  if (plugin.installed) {
    return
  }
  Vue.directive('longTxt', (el, binding) => {
    el.title = el.innerText
    el.style.overflow = 'hidden'
    el.style.textOverflow = 'ellipsis'
    el.style.whiteSpace = 'nowrap'
    el.style.width = '200px'
    if (binding.value) {
      el.style.width = binding.value + 'px'
    }
  })

  Vue.directive('drag', {
    inserted(el) {
      const dragBox = el // 获取当前元素
      dragBox.onmousedown = e => {
        // 算出鼠标相对元素的位置
        const disX = e.clientX - dragBox.offsetLeft
        const disY = e.clientY - dragBox.offsetTop
        document.onmousemove = e => {
          // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          const left = e.clientX - disX
          const top = e.clientY - disY
          // 移动当前元素
          dragBox.style.left = left + 'px'
          dragBox.style.top = top + 'px'
        }
        document.onmouseup = e => {
          // 鼠标弹起来的时候不再移动
          document.onmousemove = null
          // 预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
          document.onmouseup = null
        }
      }
    }
  })
}

export default plugin



// WEBPACK FOOTER //
// ./src/common/directives.js